import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Shanta Equity\\components\\newsroom\\NewsDetails.jsx");
